

import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { TituloNormalScren } from '../../components/TituloNormalScren';
import { useEffect, useState } from 'react';
import { dejarTresDecimales, separadorMillares } from '../../../../helpers';
import { InputSeparadorDecimal } from '../../inputs/InputSeparadorDecimal';




export const TablaTotalesPlanilla = ({ items, onCahnge, formValues }) => {


    const [totales, setTotales] = useState({ unidades:'', pBruto:0, destare:'', pesoNeto:'', pEnPie:'', total:0 });
    const { unidades, pBruto, destare, pesoNeto, pEnPie, total } = totales;


    useEffect(() => {

        const totales = items.reduce((acc, item) => {
            const huacales = Number(item.huacales) || 0;
            const avesXhuacal = Number(item.avesXhuacal) || 0;
            const peso = Number(item.pesoAvesHuacal) || 0;
            const destare = Number(item.destare) || 0;
            acc.unidades += huacales * avesXhuacal;
            acc.pBruto += peso;
            acc.destare += destare;
            return acc;
        }, { unidades: 0, pBruto: 0, destare: 0 });
        
        const { unidades, pBruto, destare } = totales;

        setTotales( (prev) => ({ ...prev, 
            unidades, pBruto, destare,
            pesoNeto: pBruto - destare,
            pEnPie: (pBruto - destare) / unidades,
            total: (pBruto - destare) * formValues.valorKilo,
        }));
    }, [items, formValues])       

    

    return (

        <Grid item sx={{my:3, width:'100%'}}>
            <TituloNormalScren titulo="Totales de Pesadas" tamanio='20' centro={false} bottom={0.5} />
            <Paper sx={{width:'100%', maxWidth:{xs:450, sm:'100%', md:'100%'}, overflowX:'auto'}}>
                <TableContainer >
                    <Table sx={{minWidth:700, overflowX:'auto'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'10%'}}>UNIDADES</TableCell>
                                <TableCell sx={{width:'15%'}}>P. BRUTO</TableCell>
                                <TableCell sx={{width:'10%'}}>DESTARE</TableCell>
                                <TableCell sx={{width:'15%'}}>P. NETO</TableCell>
                                <TableCell sx={{width:'15%'}}>PROM. PIE</TableCell>
                                <TableCell sx={{width:'20%'}}>V. KILO</TableCell>
                                {/* <TableCell sx={{width:'20%'}}>V. FACTURA</TableCell> */}
                                <TableCell sx={{width:'15%'}}>TOTAL</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            <TableRow> 
                                <TableCell>{ unidades }</TableCell>
                                <TableCell>{ dejarTresDecimales(pBruto) }Kg</TableCell>
                                <TableCell>{ dejarTresDecimales(destare) }Kg</TableCell>
                                <TableCell>{ dejarTresDecimales(pesoNeto) }Kg</TableCell>
                                <TableCell>{ dejarTresDecimales(pEnPie) }</TableCell>
                                <TableCell >
                                    <InputSeparadorDecimal required
                                        size='small'
                                        label='Valor Kilo'
                                        placeholder='Valor Kilo'
                                        fullWidth
                                        name='valorKilo'
                                        value={ formValues.valorKilo }
                                        onChange={ onCahnge }
                                    />
                                </TableCell>
                                <TableCell>{ `$${separadorMillares(total)}` }</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Grid>

    )
}
